import { render, staticRenderFns } from "./incomeForm.vue?vue&type=template&id=259bb32d&"
import script from "./incomeForm.vue?vue&type=script&lang=js&"
export * from "./incomeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports